import { useModuleContext } from '@cognitranlimited/itis-web';
export var iSheetsModuleId = Symbol('iSheetsModule');
export var useISheetsModuleContext = function () { return useModuleContext(iSheetsModuleId); };
